function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 308.8 308.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6 18.8h180c19.6 0 35.6 16 35.6 35.6v185.2c0 19.6-16 35.6-35.6 35.6h-180C16 275.2 0 259.2 0 239.6V54c0-19.2 16-35.2 35.6-35.2",
    style: {
      fill: "#4a566e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m116.4 186.4-52.8-52.8L0 197.2v42c0 19.6 16 35.6 35.6 35.6h180c19.6 0 35.6-16 35.6-35.6v-68.4l-59.6-60z",
    style: {
      fill: "#00b594"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.8,
    cy: 103.6,
    r: 22.4,
    style: {
      fill: "#ffcc03"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.2,
    cy: 232.4,
    r: 57.6,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.8 205.6c0-4.8 3.6-8.4 8.4-8.4 4.4 0 8.4 3.6 8.4 8.4V260c0 4.8-3.6 8.4-8.4 8.4s-8.4-3.6-8.4-8.4z",
    style: {
      fill: "#00b594"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.2 211.2c-3.2-3.2-3.2-8.4 0-11.6s8.4-3.2 11.6 0l19.2 19.2c3.2 3.2 3.2 8.4 0 11.6s-8.4 3.2-11.6 0z",
    style: {
      fill: "#00b594"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.2 199.6c3.2-3.2 8.4-3.2 11.6 0s3.2 8.4 0 11.6L238 230.4c-3.2 3.2-8.4 3.2-11.6 0s-3.2-8.4 0-11.6z",
    style: {
      fill: "#00b594"
    }
  }));
};
export default SvgUpload;